import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  // canlenderFilter,
  columns,
  filters,
  searchBy,
} from "../../service/PromosaleService.js";
import BasicTable from "../../Components/CommonTable/BasicTable/BasicTable.jsx";
import StoreModal from "../../Components/Modals/StoreModal/StoreModal.jsx";
import { DiscountApi } from "../../App/api/setting.js";
import PromocodeDetails from "./PromocodeDetails.jsx";
import { PromotionalMangementApi } from "../../App/api/PromotionalManagementApi.js";

const PromoSaleComp = ({ disabledFilters, pagination, handlePagination }) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [isOrderDetail, setIsOrderDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [vendorData, setVendorData] = useState(null);
  const [promosalesData, setPromoSalesData] = useState(null);

  const getAllPromocode = async () => {
    const res = await PromotionalMangementApi.promosales.getAllPromotionalSales(
      pagination,
      search
    );
    // console.log("res", res);
    // console.log("response", res?.data?.data);
    setPromoSalesData(res?.data?.data);
  };

  useEffect(() => {
    getAllPromocode();
  }, []);

  const handleCloseOrderModal = () => {
    setIsOrderDetail(false);
    setSelectedOrder(null);
  };
  const handleRowClick = (row) => {
    // console.log("row", row);
    setSelectedOrder(row);
    setIsOrderDetail(true);
  };
  const handleCellClick = (row, action) => {
    // console.log("row", row);
    try {
      DiscountApi.promocode.getAllPromocode(row?._id, {
        status: action,
      });
      getAllPromocode();
    } catch (error) {
      // console.log("error updating status", error);
    }
    // console.log("action", action);
    if (action) {
      // console.log("action", action);
    } else {
      // console.log("action", action);
    }
  };

  // console.log("selected order", selectedOrder);
  // console.log("Promo data", promosalesData);
  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    // console.log("clearPagination", clearPagination);
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    console.table("name,value", name, value);
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    // console.log("data", data);
    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllPromocode();
  }, [pagination, search]);

  const DataFilter = filters.filter((f) =>
    disabledFilters ? !disabledFilters.includes(f.inputName) : true
  );

  // console.log("data filter", DataFilter);

  return (
    <div className="p-5">
      <BasicTable
        // data={[]}

        columns={columns}
        data={promosalesData?.sales}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: promosalesData?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: promosalesData?.totalPages || 1,
          totalCount: promosalesData?.totalCount || 1,
        }}
        onCellClick={(e) => {
          // console.log("Cell Data", e);
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        filters={DataFilter}
        WeekRange={false}
        MonthRange={true}
        // canlenderFilter={canlenderFilter}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
      />
      <PromocodeDetails
        handleRowClick={handleRowClick}
        isOrderDetail={isOrderDetail}
        handleCloseOrderModal={handleCloseOrderModal}
        promosalesData={selectedOrder}
      />
      <StoreModal
        itemData={vendorData}
        setToggleUsersDetails={(v) => {
          setVendorData(null);
        }}
        toggleUsersDetails={Boolean(vendorData)}
      />
    </div>
  );
};

export default PromoSaleComp;
